"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function CloseThin(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5,3 L9.5,8.5 L15,8.5 L15,9.5 L9.5,9.5 L9.5,15 L8.5,15 L8.5,9.5 L3,9.5 L3,8.5 L8.5,8.5 L8.5,3 L9.5,3 Z", transform: "rotate(45 9.707 7.293)" })));
}
exports.default = CloseThin;
//# sourceMappingURL=CloseThin.js.map